module.exports = __webpack_public_path__ + "static/ec-b526c480b1ec84810c0c3e8f74ba9c6b.svg";